import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class GalleryService {

    static getGallery(item) {

        let api = `${API_BASE_URL}${API_PATHS.getGallery}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addGallery(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addGallery}`;
        return axiosInstance
            .post(api, data)

    }

    static editGallery(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editGallery}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteGallery(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteGallery}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default GalleryService;
